import "./MensajeCancelarTurno.css";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import { useContext, useState } from "react";
import {
  cancelacionReset,
  wsDeleteTurnoQr,
  wsDeleteTurnolaboratorio,
  wsDeleteTurnoSesionKinesio,
} from "../../../context/Actions/turnos/cancelacion";
import { PortalContext } from "../../../context/Provider";
import { hideModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { hideSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import { cancelarKinesioFlag } from "../../../context/Actions/turnos/turnosPaciente";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { loginTokenReset } from "_+_Portal/context/Actions/token/loginToken";

const MensajeCancelarTurno = ({
  titulo,
  textoNegrita,
  texto,
  danger,
  items,
  idturno,
  idProtocolo,
  idTurnoSesion,
  idPacienteFamiliar,
  flgSesion,
  esUltimo,
}) => {
  const {
    cancelacionDispatch,
    segundoModalDispatch,
    modalState,
    modalDispatch,
    segundoModalState,
    turnosPacienteDispatch,
    cancelacionState,
    tokenDispatch,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const [motivoCancelacion, setMotivoCancelacion] = useState();
  const [showOtroMotivo, setShowOtroMotivo] = useState(false);
  const [motivoOtro, setMotivoOtro] = useState();

  const onChangeMotivoCancelacion = (e) => {
    if (e.id === 157) {
      setShowOtroMotivo(true);
    } else {
      setShowOtroMotivo(false);
    }
    setMotivoCancelacion(JSON.parse(JSON.stringify(e)).id);
  };

  const onChangeMotivoOtro = (e) => {
    setMotivoOtro(e.target.value);
  };

  const dissmiss = () => {
    if (segundoModalState.segundoModal.show) {
      hideSegundoModal()(segundoModalDispatch);
      cancelacionReset()(cancelacionDispatch);
      loginTokenReset()(tokenDispatch);
    }
  };
  const cerrarModal = () => {
    if (modalState.modal.show) {
      hideModal()(modalDispatch);
      cancelacionReset()(cancelacionDispatch);
      loginTokenReset()(tokenDispatch);
    }
  };

  const cancelarTurno = () => {
    if (motivoCancelacion !== undefined) {
      if (idProtocolo > 0) {
        wsDeleteTurnolaboratorio(
          idturno,
          motivoCancelacion,
          motivoOtro === undefined ? "-" : motivoOtro,
          idPacienteFamiliar
        )(cancelacionDispatch);
        if (
          cancelacionState.cancelacion.error === false ||
          cancelacionState.cancelacion.error === null
        ) {
          cancelarKinesioFlag()(turnosPacienteDispatch);
        }
        dissmiss();
        cerrarModal();
      }
      if (idTurnoSesion > 0 && flgSesion === true) {
        wsDeleteTurnoSesionKinesio(
          idTurnoSesion,
          motivoCancelacion,
          motivoOtro === undefined ? "-" : motivoOtro,
          idPacienteFamiliar
        )(cancelacionDispatch);
        if (
          cancelacionState.cancelacion.error === false ||
          cancelacionState.cancelacion.error === null
        ) {
          cancelarKinesioFlag()(turnosPacienteDispatch);
        }
        dissmiss();
        cerrarModal();
      } else if (!(idProtocolo > 0)) {
        wsDeleteTurnoQr(
          idturno,
          motivoCancelacion,
          motivoOtro === undefined ? "-" : motivoOtro
        )(cancelacionDispatch);
      }
      if (
        cancelacionState.cancelacion.error === false ||
        cancelacionState.cancelacion.error === null
      ) {
        cancelarKinesioFlag()(turnosPacienteDispatch);
      }
      dissmiss();
      cerrarModal();
    } else {
      showToaster(
        {
          texto: "Seleccione un motivo para poder cancelar",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  return (
    <>
      <HeaderModal
        titulo={titulo}
        dissmiss={segundoModalState.segundoModal.show ? dissmiss : cerrarModal}
        danger={true}
      />
      <div className="ptur-modalBody-container">
        {(texto || textoNegrita) && (
          <div className="ptur-modalBody-mensaje">
            <div className="ptur-MensajeCancelarTurno-pregunta">
              {textoNegrita && (
                <span className="rb16m c-latex10">
                  {textoNegrita === "" ? "Error inesperado." : textoNegrita}
                </span>
              )}
              {texto && (
                <span className="rb16t c-latex10">
                  {texto === "" ? "" : texto}
                </span>
              )}
            </div>
            {items && (
              <div className="ptur-MensajeCancelarTurno-dropdown-container">
                <div className="ptur-MensajeCancelarTurno-dropdown rb16t c-latex10">
                  <Dropdown
                    datos={items}
                    onChange={onChangeMotivoCancelacion}
                    campoCodigo="id"
                    descripcion="descripcion"
                    placeholder="Seleccione un Motivo de Cancelación"
                    name="txtMotivoCancelacion"
                    errorStr="Se requiere seleccionar un motivo."
                    mobileWidth={true}
                    isRequired={true}
                  />
                </div>
              </div>
            )}
            {showOtroMotivo && (
              <div className="ptur-MensajeCancelarTurno-textarea-container">
                <InputV1
                  disabledEjemplo={true}
                  inputType="textarea"
                  name="txtMotivoOtro"
                  placeholderText="Agregar un motivo (Opcional)"
                  onChange={onChangeMotivoOtro}
                  maxLength="100"
                  className="ptur-MensajeCancelarTurno-otroMotivo rb16m"
                  isRequired={false}
                />
              </div>
            )}
          </div>
        )}
        <div className="ptur-MensajeCancelarTurno-botones">
          <button
            className="btn ptur-MensajeCancelarTurno-no"
            onClick={
              segundoModalState.segundoModal.show ? dissmiss : cerrarModal
            }
          >
            No
          </button>
          <button
            className="btn ptur-MensajeCancelarTurno-cancelar"
            onClick={cancelarTurno}
          >
            Si, cancelar
          </button>
        </div>
      </div>
    </>
  );
};

export default MensajeCancelarTurno;
